module.exports = "https://cdn2-fs.clearscore.com/flux/images/70a86767fdb09cd3112dba39b1e73813.jpg";